import { Toaster as Sonner, toast } from "sonner"

// App is dark-only. Force the dark theme and use literal hsl colors (no CSS-var
// indirection) so toasts render with a solid background even in hardened/privacy
// browsers that fail to resolve `hsl(var(--token) / a)`.
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[hsl(240_8%_10%)] group-[.toaster]:text-white group-[.toaster]:border group-[.toaster]:border-[hsl(240_6%_20%)] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[hsl(0_0%_72%)]",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-[hsl(240_6%_20%)] group-[.toast]:text-[hsl(0_0%_72%)]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
